import { extractText } from "@/shared/utils";

export type ColumnProps<T> = {
    key?: React.Key;
    header: React.ReactNode;
    render: (row: T, index: number) => React.ReactNode;
}

type rColumn = { key: string; header: string; };
type rRow = Record<string, string>;

export function toExportFormat<T = any>(columns: ColumnProps<T>[], data: T[]) {
    const pColumns = columns.map((c, i) => ({ ...c, header: String(c.header), key: String(c.key || i) }));

    const realData = data.map((row, rowIndex) => {
        return pColumns.map(column => {
            return { key: column.key, value: String(extractText(column.render(row, rowIndex))) };
        }).reduce((prev, { key, value }) => {
            prev[key] = value;
            return prev;
        }, {} as rRow)
    });

    const realColumn = pColumns.map(c => ({
        key: c.key,
        header: c.header
    } as rColumn));

    return [realColumn, realData] as [rColumn[], rRow[]]
}